import React from 'react'
import PropTypes from 'prop-types'
import { Button, buttonPropTypes } from '.'
import { withDialogs } from 'decorators'

const ConfirmButton = (props) => {
  const handleClick = ({ confirmTitle, confirmMessage, onConfirm }) => () => props.showConfirm({ confirmTitle, confirmMessage, onConfirm })
  const {
    confirmTitle, confirmMessage, onConfirm, showDialog, hideDialog, showConfirm, showAlert, children,
    localize, dispatch, ...otherProps } = props
  return (
    <Button onClick={handleClick({ confirmTitle, confirmMessage, onConfirm })} {...otherProps}>{children}</Button>
  )
}

ConfirmButton.propTypes = {
  ...buttonPropTypes,
  confirmTitle: PropTypes.string,
  confirmMessage: PropTypes.string,
  title: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired
}
ConfirmButton.defaultProps = {
  width: 150,
  marginLeft: 0,
  marginRight: 0,
  uppercase: true,
  size: 'medium',
  variant: 'contained',
  color: 'primary',
  isLoading: false
}

export default withDialogs(ConfirmButton)
